<template>
  <div>
    <v-select
      v-model="selectedResource"
      :items="schedules"
      label="Resource"
      multiple
      clearable
      item-title="label"
      item-value="id"
      variant="outlined"
      :density="density"
      :class="{ 'filter-select': !isMobile }"
                          
      :color="currentCalendar.color"
      @update:model-value="handleSelectResource"
    >
      <template v-slot:selection="{ item, index }">
        <v-chip
          v-if="index === selectedResource.length - 1"
          label
          small
          closable
          :color="currentCalendar.color"
          class="rounded-md"
          @click:close="removeResourceSelectedChip(item.value)"
        >
          <span>{{ item.title }}</span>
          <template v-slot:close>
            <v-icon color="red" size="15">mdi-close</v-icon>
          </template>
        </v-chip>
        <span
          v-if="index === selectedResource.length - 2"
          class="grey--text caption"
        >
            +{{ selectedResource.length - 1 }}
        </span>
      </template>
    </v-select>

    <v-select
      v-if="isODCalendar"
      v-model="selectedClinics"
      :items="allClinics"
      label="Clinics"
      multiple
      clearable
      item-title="clinicName"
      item-value="ClinicNum"
      variant="outlined"
      :density="density"
      :class="{ 'filter-select': !isMobile }"
      :color="currentCalendar.color"
      @update:model-value="handleSelectClinics"
    >
      <template v-slot:selection="{ item, index }">
        <v-chip
          v-if="index === selectedClinics.length - 1"
          label
          small
          closable
          :color="currentCalendar.color"
          class="rounded-md"
          @click:close="removeClinicSelectedChip(item.value)"
        >
          <span>{{ item.title }}</span>
          <template v-slot:close>
            <v-icon color="red" size="15">mdi-close</v-icon>
          </template>
        </v-chip>
        <span
          v-if="index === selectedClinics.length - 2"
          class="grey--text caption"
        >
        +{{ selectedClinics.length - 1 }}
        </span>
      </template>
    </v-select>

    <v-select
      v-if="isODCalendar"
      v-model="selecteddoctors"
      :items="doctorsList"
      label="Doctors"
      multiple
      clearable
      item-title="provAbbr"
      item-value="provAbbr"
      variant="outlined"
      :density="density"
      :class="{ 'filter-select': !isMobile }"
      :color="currentCalendar.color"
      @update:model-value="handleSelectDoctors"
    >
      <template v-slot:selection="{ item, index }">
        <v-chip
          v-if="index === selecteddoctors.length - 1"
          label
          small
          closable
           :color="currentCalendar.color"
          class="rounded-md"
          @click:close="removeDoctorSelectedChip(item.value)"
        >
          <span>{{ item.title }}</span>
          <template v-slot:close>
            <v-icon color="red" size="15">mdi-close</v-icon>
          </template>
        </v-chip>
        <span
          v-if="index === selecteddoctors.length - 2"
          class="grey--text caption"
        >
        +{{ selecteddoctors.length - 1 }}
        </span>
      </template>
    </v-select>

    <v-select
      v-if="isDSSCalendar"
      v-model="selectedAuthors"
      :items="authorsList"
      label="Created By"
      multiple
      clearable
      item-title="label"
      item-value="author"
      variant="outlined"
      :density="density"
      :class="{ 'filter-select': !isMobile }"
      :color="currentCalendar.color"
      @update:model-value="handleSelectAuthors"
    >
      <template v-slot:selection="{ item, index }">
        <v-chip
          v-if="index === selectedAuthors.length - 1"
          label
          small
          closable
           :color="currentCalendar.color"
          class="rounded-md"
          @click:close="removeAuthorSelectedChip(item.value)"
        >
          <span>{{ item.title }}</span>
          <template v-slot:close>
            <v-icon color="red" size="15">mdi-close</v-icon>
          </template>
        </v-chip>
        <span
          v-if="index === selectedAuthors.length - 2"
          class="grey--text caption"
        >
        +{{ selectedAuthors.length - 1 }}
        </span>
      </template>
    </v-select>

    <v-select
      v-if="isDSSCalendar"
      v-model="selectedStatus"
      :items="eventStatus"
      label="Event Status"
      multiple
      clearable
      variant="outlined"
      :density="density"
      :class="{ 'filter-select': !isMobile }"
      :color="currentCalendar.color"
      @update:model-value="handleSelectStatus"
    >
      <template v-slot:selection="{ item, index }">
        <v-chip
          v-if="index === selectedStatus.length - 1"
          label
          small
          closable
          :color="currentCalendar.color"
          class="rounded-md"
          @click:close="removeStatusSelectedChip(item.value)"
        >
          <span>{{ item.title }}</span>
          <template v-slot:close>
            <v-icon color="red" size="15">mdi-close</v-icon>
          </template>
        </v-chip>
        <span
          v-if="index === selectedStatus.length - 2"
          class="grey--text caption"
        >
          +{{ selectedStatus.length - 1 }}
        </span>
      </template>
    </v-select>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { EVENT_STATUS } from "@/constants/constantsValues.js";
export default {
  name: "CalendarFilter",
  props: {
    schedules: { type: Array, required: true },
    selectedResourceValues: { type: Array, default: () => [] },
    selectedClinicValues: { type: Array, default: () => [] },
    selectedDoctorValues: { type: Array, default: () => [] },
    selectedAuthorValues: { type: Array, default: () => [] },
    selectedStatusValues: { type: Array, default: () => [] },
  },
  data() {
    return {
      selectedResource: this.selectedResourceValues,
      selectedClinics: this.selectedClinicValues,
      selecteddoctors: this.selectedDoctorValues,
      selectedAuthors: this.selectedAuthorValues,
      selectedStatus: this.selectedStatusValues,
    };
  },
  computed: {
    ...mapGetters("window", ["isMobile"]),
    ...mapGetters("calendar", [
      "currentCalendar",
      "isODCalendar",
      "isDSSCalendar",
      "doctorsList",
      "authorsList",
      "allClinics",
    ]),
    eventStatus() {
      return Object.values(EVENT_STATUS);
    },
    density(){
      return this.isMobile ? "comfortable" : "compact"
    }
  },
  methods: {
    handleSelectResource(newValues) {
      this.selectedResource = newValues;
      this.$emit("update:selectedResourceValues", this.selectedResource);
    },
    handleSelectClinics(newValues) {
      this.selectedClinics = newValues;
      this.$emit("update:selectedClinicValues", this.selectedClinics);
    },
    handleSelectDoctors(newValues) {
      this.selecteddoctors = newValues;
      this.$emit("update:selectedDoctorValues", this.selecteddoctors);
    },
    handleSelectAuthors(newValues) {
      this.selectedAuthors = newValues;
      this.$emit("update:selectedAuthorValues", this.selectedAuthors);
    },
    handleSelectStatus(newValues) {
      this.selectedStatus = newValues;
      this.$emit("update:selectedStatusValues", this.selectedStatus);
    },
    removeResourceSelectedChip(value) {
      this.selectedResource = this.selectedResource.filter((v) => v !== value);
      this.$emit("update:selectedResourceValues", this.selectedResource);
    },
    removeClinicSelectedChip(value) {
      this.selectedClinics = this.selectedClinics.filter((v) => v !== value);
      this.$emit("update:selectedClinicValues", this.selectedClinics);
    },
    removeDoctorSelectedChip(value) {
      this.selecteddoctors = this.selecteddoctors.filter((v) => v !== value);
      this.$emit("update:selectedDoctorValues", this.selecteddoctors);
    },
    removeAuthorSelectedChip(value) {
      this.selectedAuthors = this.selectedAuthors.filter((v) => v !== value);
      this.$emit("update:selectedAuthorValues", this.selectedAuthors);
    },
    removeStatusSelectedChip(value) {
      this.selectedStatus = this.selectedStatus.filter((v) => v !== value);
      this.$emit("update:selectedStatusValues", this.selectedStatus);
    }
  },
};
</script>

<style scoped>
.filter-select {
  min-height: 30px;
  max-height: 30px;
  min-width: 160px;
  max-width: 250px;
  margin-bottom: 2px;
  margin-top: 4px;
}
</style>
